if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.form.addEventListener('input', this.onFormValueChange.bind(this));
      this.form.addEventListener('change', this.onFormValueChange.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    setLoadingState(isLoading) {
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (!spinner) return;

      spinner.classList.toggle('hidden', !isLoading);
      if (spinner.hasAttribute('data-theme-quick-view-spinner')) {
        spinner.hidden = !isLoading;
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.isSubmitting || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const source = this.form.dataset?.themePurchaseSource === 'sticky' ? 'sticky' : 'primary';
      if (this.form.dataset) delete this.form.dataset.themePurchaseSource;
      const isPdp = Boolean(this.closest('.theme-main-product'));
      const submittedVariantId = this.form.querySelector('[name=id]')?.value || '';
      const reportPurchase = (phase, outcome) => {
        if (!isPdp) return;
        document.dispatchEvent(new CustomEvent('theme:pdp:purchase', {
          detail: { form: this.form, source, phase, outcome, variantId: submittedVariantId }
        }));
      };
      reportPurchase('attempt');

      this.handleErrorMessage();

      this.isSubmitting = true;
      const submittedFormValueRevision = this.formValueRevision || 0;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.setLoadingState(true);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(source === 'sticky' ? this.submitButton : document.activeElement);
      }
      config.body = formData;

      let addSucceeded = false;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          if (response.status) {
            if ((this.formValueRevision || 0) === submittedFormValueRevision) {
              this.handleErrorMessage(response.description || response.message || 'Unable to add this product right now. Please try again.');
            }
            reportPurchase('result', 'rejected');
            return;
          }
          addSucceeded = true;
          reportPurchase('result', 'accepted');

          const notifyCartAdd = () => {
            document.dispatchEvent(new CustomEvent('theme:cart:add', {
              detail: {
                response,
                form: this.form,
                cartSurfacePresent: Boolean(this.cart)
              }
            }));
          };

          const notifyQuickViewBeforeCartRender = () => {
            const quickViewDialog = this.closest('[data-theme-quick-view-dialog]');
            const quickViewController = window.themeQuickViewController;
            if (!quickViewDialog || !quickViewController || typeof quickViewController.beforeCartRender !== 'function') {
              return false;
            }

            return quickViewController.beforeCartRender({
              cart: this.cart,
              response,
              form: this.form
            });
          };

          if (!this.cart) {
            notifyQuickViewBeforeCartRender();
            notifyCartAdd();
            return;
          }

          const renderCart = async () => {
            if (typeof this.cart.prepareContents === 'function') {
              await this.cart.renderContents(response);
              notifyQuickViewBeforeCartRender();
              this.cart.open();
            } else {
              notifyQuickViewBeforeCartRender();
              await this.cart.renderContents(response);
            }
            notifyCartAdd();
          };

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            await new Promise((resolve) => {
              document.body.addEventListener('modalClosed', resolve, { once: true });
              quickAddModal.hide(true);
            });
            await renderCart();
          } else {
            await renderCart();
          }
        })
        .catch((e) => {
          console.error(e);
          if (addSucceeded) {
            window.location.assign(routes.cart_url);
            return;
          }
          if ((this.formValueRevision || 0) === submittedFormValueRevision) {
            this.handleErrorMessage('Unable to add this product right now. Please try again.');
          }
          reportPurchase('result', 'error');
        })
        .finally(() => {
          this.isSubmitting = false;
          this.submitButton.classList.remove('loading');
          if (!this.submitButton.disabled) this.submitButton.removeAttribute('aria-disabled');
          this.setLoadingState(false);
        });
    }

    onFormValueChange(event) {
      if (!event.target?.matches?.('[name="id"], [name="quantity"]')) return;
      this.formValueRevision = (this.formValueRevision || 0) + 1;
      this.handleErrorMessage();
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      this.errorMessage.textContent = errorMessage || '';
    }
  });
}
